export const maxWidthContainer = 1400;
